import { useEffect, useRef, useState } from 'react';

const IDLE_STATE = {
    status: 'idle',
    data: null,
    error: null,
};

function toError(error) {
    return {
        code:
            error?.response?.data?.code ||
            error?.code ||
            'elevation_request_failed',
        message:
            error?.response?.data?.message ||
            error?.message ||
            'Elevation request failed.',
    };
}

export default function useElevationRequest(request, requestKey, debounceMs = 100) {
    const [state, setState] = useState(IDLE_STATE);
    const requestVersionRef = useRef(0);
    const requestRef = useRef(request);
    requestRef.current = request;

    useEffect(() => {
        const requestVersion = ++requestVersionRef.current;
        if (!requestRef.current) {
            setState(IDLE_STATE);
            return undefined;
        }

        setState({ status: 'loading', data: null, error: null });
        const timer = window.setTimeout(async () => {
            try {
                const data = await requestRef.current();
                if (requestVersion === requestVersionRef.current) {
                    setState({ status: 'success', data, error: null });
                }
            } catch (error) {
                if (requestVersion === requestVersionRef.current) {
                    setState({ status: 'error', data: null, error: toError(error) });
                }
            }
        }, debounceMs);

        return () => window.clearTimeout(timer);
    }, [requestKey, debounceMs]);

    return state;
}
